import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import adminService from "../../Services/adminService";
import userService from "../../Services/userService";
import moment from "moment";
import {
  InputLabel,
  CardContent,
  Select,
  MenuItem,
  Paper,
  Card,
  Button,
  Tabs,
  Tab,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  FormControl
} from "@material-ui/core";
import { Link } from "react-router-dom";

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

class AdminAssignmentsManager extends Component {
  state = {
    currentTab: 0,
    adminSpecificAssignments: null,
    adminSpecificAssignmentsCopy: null,
    salesAccts: ["1", 1, 1, 1],
    salesAcctSelected: ""
  };

  async componentDidMount() {
    let salesAccts = await adminService.getSalesAccountsList();
    if (salesAccts.success) this.setState({ salesAccts: salesAccts.salesAccs });
    adminService.salesListAndClientAssignments().then((res) => {
      if (res["success"]) {
        this.setState({
          adminSpecificAssignments: res["assignments"],
          adminSpecificAssignmentsCopy: res["assignments"]
        });
      }
    });
  }

  render() {
    return (
      <div className="mt-50 mb-50">
        <Card>
          <CardContent>
            <h3>המשימות שלי</h3>
            <div className="mb-20">
              <FormControl className="ml-20 mr-20">
                <InputLabel className="align-select-label">סינון משימות</InputLabel>
                <Select className="select-field" value={this.state.filterKeyTag} onChange={this.filterAssignments} displayEmpty>
                  <MenuItem value="all">ללא סינון</MenuItem>
                  <MenuItem value="btax">B-Tax</MenuItem>
                  <MenuItem value="bquick">Bquick</MenuItem>
                  <MenuItem value="courses">קורסים</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="ml-20 mr-20">
                <InputLabel className="align-select-label">סינון לפי איש מכירות</InputLabel>
                <Select
                  className="select-field"
                  value={this.state.salesAcctSelected || ""}
                  onChange={(e) => this.findAssignmentsBySalesPerson(e.target.value)}
                  displayEmpty
                >
                  {this.state.salesAccts
                    ? this.state.salesAccts.map((item) => {
                        return (
                          <MenuItem key={item._id} value={item._id}>
                            {item.firstName}
                          </MenuItem>
                        );
                      })
                    : null}
                </Select>
              </FormControl>
            </div>

            <div className="mb-40">
              <Paper square>
                <Tabs
                  value={this.state.currentTab}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={this.onAssignmentTabChange}
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="משימות לביצוע" />
                  <Tab label="משימות עתידיות" />
                </Tabs>
              </Paper>
            </div>

            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead style={{ background: `orange` }}>
                  <TableRow>
                    <StyledTableCell align="center">תאריך יעד</StyledTableCell>
                    <StyledTableCell align="right">שם משרד</StyledTableCell>
                    <StyledTableCell align="right">משימה</StyledTableCell>
                    <StyledTableCell align="right">משימה שייכת לחברה</StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.adminSpecificAssignments
                    ? this.state.adminSpecificAssignments.map((assignment, index) => {
                        var dueDate = userService.fixUtcFormat(assignment.dueDate);
                        return (
                          <StyledTableRow key={index}>
                            <StyledTableCell className="cell120" align="center">
                              {moment(dueDate).format("DD-MM-YYYY")}
                              <br />
                              {moment(dueDate).format("HH:mm")}
                            </StyledTableCell>
                            <StyledTableCell align="right">{assignment.officeName}</StyledTableCell>
                            <StyledTableCell align="right">{assignment.assignmentTxt}</StyledTableCell>
                            <StyledTableCell className="tags-color" align="right">
                              {assignment.assignmentTags.replace(/:/g, " / ")}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Link to={"/admin/specific-user/" + assignment.userId}>
                                <Button color="primary" variant="contained" size="small">
                                  כניסה לכרטיס לקוח
                                </Button>
                              </Link>
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </div>
    );
  }

  findAssignmentsBySalesPerson = (val) => {
    adminService.salesListAndClientAssignments(val).then((res) => {
      if (res["success"]) {
        this.setState({
          adminSpecificAssignments: res["assignments"],
          adminSpecificAssignmentsCopy: res["assignments"],
          salesAcctSelected: val
        });
      }
    });
  };

  filterAssignments = (e) => {
    var filterKey = e.target.value;

    if (filterKey === "all") {
      this.setState({
        adminSpecificAssignments: [...this.state.adminSpecificAssignmentsCopy],
        filterKeyTag: filterKey
      });
    } else {
      var getAssignments = this.state.adminSpecificAssignmentsCopy.filter((item) => item.assignmentTags.includes(filterKey));
      this.setState({ adminSpecificAssignments: getAssignments, filterKeyTag: filterKey });
    }
  };

  onAssignmentTabChange = (e) => {
    if (e.target.innerText === "משימות לביצוע") {
      if (this.state.currentTab === 0) return;
      adminService.salesListAndClientAssignments().then((res) => {
        if (res["success"]) {
          this.setState({
            currentTab: 0,
            adminSpecificAssignments: res["assignments"],
            adminSpecificAssignmentsCopy: res["assignments"]
          });
        }
      });
    } else {
      if (this.state.currentTab === 1) return;
      adminService.getFutureAssignmentsSalesUser().then((res) => {
        if (res["success"]) {
          this.setState({
            currentTab: 1,
            adminSpecificAssignments: res["assignments"],
            adminSpecificAssignmentsCopy: res["assignments"]
          });
        }
      });
    }
  };
}

export default AdminAssignmentsManager;
